/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Generate_DocsInputs */

const en_orders_generate_docs = /** @type {(inputs: Orders_Generate_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Docs`)
};

const es_orders_generate_docs = /** @type {(inputs: Orders_Generate_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar documentos`)
};

/**
* | output |
* | --- |
* | "Generate Docs" |
*
* @param {Orders_Generate_DocsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_generate_docs = /** @type {((inputs?: Orders_Generate_DocsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Generate_DocsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_generate_docs(inputs)
	return es_orders_generate_docs(inputs)
});